import React from 'react';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import magalu from '../../assets/images/magalu.svg';

import Strips from '../Strips';

const mobileHeaderStyles = makeStyles({
  header: {
    background: '#0086ff',
    position: 'relative',
    height: '56px',
    width: '100%',
    zIndex: '999',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& a': {
      padding: '21px 15px 13px',
      '& img': {
        width: '90px',
      },
    },
  },
});

export default function MobileHeader() {
  const classes = mobileHeaderStyles();

  return (
    <>
      <header className={classes.header}>
        <div className={classes.wrapper}>
          <Link href="https://www.magalu.com.br/">
            <img src={magalu} alt="Magazine Luiza" />
          </Link>
        </div>
      </header>
      <Strips />
    </>
  );
}
